/** @module Sourcing/CopySupplierRequestRightWidget */
define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "csi/html",
    "dojo/text!./CopySupplierRequestRightWidget.html"
], function(declare,_WidgetBase,_TemplatedMixin,html,template) {

	return declare([_WidgetBase, _TemplatedMixin], {
        templateString: template,

        numSuppliers: 0,
        numFactories: 0,
        numQuotes: 0,
        numSamples: 0,
        numProducts: 0,
        numFoodSKUs: 0,

        _setNumProductsAttr: {node: "productsNode", type: "innerText"},
        _setNumQuotesAttr: {node: "quotesNode", type: "innerText"},
        _setNumSamplesAttr: {node: "samplesNode", type: "innerText"},
        _setNumSuppliersAttr: {node: "suppliersNode", type: "innerText"},
        _setNumFactoriesAttr: {node: "factoriesNode", type: "innerText"},
        _setNumFoodSKUsAttr: {node: "foodSKUsNode", type: "innerText"},

        useFoodSKUsNode: function(visible) {
            html.setVisible(this.productsNode.parentNode, !visible);
            html.setVisible(this.foodSKUsNode.parentNode, visible);
        },

        useSupplierOrFactoryNodes: function(supplierVisible, factoryVisible) {
            html.setVisible(this.suppliersNode.parentNode, supplierVisible);
            html.setVisible(this.factoriesNode.parentNode, factoryVisible);
        }
	});
});

